import React from 'react';
import { Link as ReactRouterLink } from "react-router-dom";

import { getQueryParams, queryObjectToString } from '../lib/urlUtils'

export default function Link(props){
    let newProps = {...props}

    /* merge query string specified in props.to with query string on
       currently loaded page, with that in props.to taking precedence */

    if (typeof props.to === 'string' || props.to instanceof String) {
        /* newProps.to is a string representation of the Link location,
           created by concatenating the location’s pathname, search,
           and hash propertie */

        /* First, parse props.to string
           See: https://www.abeautifulsite.net/parsing-urls-in-javascript */
        let parser = document.createElement('a'), searchObject = {}, queries, split, i;
        parser.href = props.to

        newProps.to = {
            pathname: parser.pathname,
            hash: parser.hash,
            /* merge query strings */
            search: queryObjectToString({
                ...(getQueryParams()),
                ...(getQueryParams(parser.search))
            })
        }
    } else if (typeof v === "object") {
        /* merge query strings */
        newProps.to.search = queryObjectToString({
            ...(getQueryParams()),
            ...(getQueryParams(props.to.search))
        })
    }
    // else, is a function; don't do anything (TODO: implement this?)


    return (
        <ReactRouterLink {...newProps}/>
    )
}
